import { render, staticRenderFns } from "./MyChatList.vue?vue&type=template&id=7c63715b&scoped=true&"
import script from "./MyChatList.vue?vue&type=script&lang=js&"
export * from "./MyChatList.vue?vue&type=script&lang=js&"
import style0 from "./MyChatList.vue?vue&type=style&index=0&id=7c63715b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c63715b",
  null
  
)

export default component.exports